import React from 'react';

import { useSite } from '../../hooks/use-site';
import TermsAndConditionsEN from './self-co/terms/en';
import TermsAndConditionsDE from './self-co/terms/de';

export default function TextTerms() {
  const { locale } = useSite();

  return locale === 'en' ? <TermsAndConditionsEN /> : <TermsAndConditionsDE />;
}
